import { fetchAttachments } from '../../api/Api';
import { SET_BUILDING_ATTACHMENTS } from './actiontypes';

const setBuildingAttachments = (buildingId, attachments) => ({
  type: SET_BUILDING_ATTACHMENTS,
  attachments,
  buildingId,
});

const fetchAttachmentsCreator = (buildingId) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  fetchAttachments(buildingId, jwt).then((attachments) =>
    dispatch(setBuildingAttachments(buildingId, attachments))
  );
};

export default fetchAttachmentsCreator;
